import { motion } from "framer-motion";
import { fadeUp } from "@/lib/motion";

// Wrapper that fades + translates its children up as they enter the viewport.
export default function Reveal({ children, variants = fadeUp, className = "", amount = 0.3, once = true, ...rest }) {
  return (
    <motion.div
      className={className}
      variants={variants}
      initial="hidden"
      whileInView="show"
      viewport={{ once, amount }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
